import { useMutation, UseMutationResult } from 'react-query'
import { request } from '../request'

export const useAuthLogin = (): UseMutationResult<
  { data: Record<string, unknown> },
  Error,
  { email: string; password: string; next?: string | null },
  unknown
> => {
  return useMutation((data: { email: string; password: string; next?: string | null }) =>
    request<{ data: Record<string, unknown> }>({
      url: '/auth/login',
      method: 'POST',
      data: data,
    }),
  )
}
